import { useQuery } from "@tanstack/vue-query"

export type UserMeetingResponse = Awaited<ReturnType<typeof UserService.getUserMeetings>>
export const useUserMeetings = (
  params?: Ref<PaginationParams>,
  options?: QueryOptions<UserMeetingResponse>
) => {
  return useQuery<UserMeetingResponse>({
    queryKey: ["UserService.getUserMeetings", params],
    queryFn: ({ signal }) => UserService.getUserMeetings({ signal, params: params?.value }),
    ...options,
  })
}
